import { RxJSCurrentState, useRxJSState } from '../../React/Common/Hooks/useRxJSState'
import { CRMTypesResponse } from '../../NonReact/common/Types/Types'
import { crmTypes$ } from '../../NonReact/common/RxJS/CRMTypesState'
import { CRMConfigurationTemplateType } from '../Components/Organisms/CRMConfiguration/Modal/Constants/Constants'

export type CRMTypes = RxJSCurrentState<Record<CRMConfigurationTemplateType, CRMTypesResponse[]>>

export const useCRMTypes = (): CRMTypes =>
    useRxJSState<Record<CRMConfigurationTemplateType, CRMTypesResponse[]>>(crmTypes$)
